export default "__VITE_ASSET__Vo52wtvR__"